import {
  PERSON_SIMILARITY_RESULT_RESPONSE,
  PERSON_SIMILARITY_RESULT_FAILURE,
  PERSON_SIMILARITY_RESULT_REQUEST,
  PERSON_SIMILARITY_KEYWORD_UPDATE
} from "../../actions/types";

const initialState = {
  error: false,
  isInitialScreen: true,
  experts: [],
  keywords: [],
  grouped_keywords: [],
  totalExperts: "-",
  title: "",
  abstract: "",
  applicant: [],
  selectedTopics: [],
  isFetching: false,
  isResultError: false
};

const setRequest = (state, action) => {
  return {
    ...state,
    isFetching: true,
    isResultError: false,
    isInitialScreen: false,
    experts: []
  };
};

const setFailure = (state, action) => {
  return {
    ...state,
    isFetching: false,
    isResultError: true,
    isInitialScreen: false
  };
};

const setResponse = (state, action) => {
  let { results = [], totalExperts = 0 } = action.payload;
  return {
    ...state,
    isFetching: false,
    isResultError: false,
    experts: results || [],
    isInitialScreen: false,
    totalExperts
  };
};

const updateKeywords = (state, action) => {
  let { keywords } = action.payload;
  return {
    ...state,
    keywords: keywords || []
  };
};

const inputs = (state = initialState, action) => {
  switch (action.type) {
    case PERSON_SIMILARITY_RESULT_RESPONSE:
      return setResponse(state, action);
      break;

    case PERSON_SIMILARITY_RESULT_FAILURE:
      return setFailure(state, action);
      break;

    case PERSON_SIMILARITY_RESULT_REQUEST:
      return setRequest(state, action);

    case PERSON_SIMILARITY_KEYWORD_UPDATE:
      return updateKeywords(state, action);

    default:
      return state;
      break;
  }
};

export default inputs;
